// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const InstallTrigger: any

export const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('safari') > -1 && ua.indexOf('chrome') < 0
}

export const isFirefox = typeof InstallTrigger !== 'undefined'
